import { createApp } from 'vue';
import { createPinia } from 'pinia';
import { Capacitor } from '@capacitor/core';
import ElementPlus from 'element-plus';
import zhCn from 'element-plus/es/locale/lang/zh-cn';
import 'element-plus/dist/index.css';
import './styles.css';
import App from './App.vue';
import { initializeNativeApp } from './native';
import router from './router';

if (Capacitor.isNativePlatform()) document.documentElement.classList.add('native-platform');

createApp(App).use(createPinia()).use(ElementPlus, { locale: zhCn }).use(router).mount('#app');
void initializeNativeApp(router);
